import React from 'react'
import { ScriptContent } from './script-parser-effects'
import type { Parser } from '.'

export const scriptParser: Parser = node => {
  if (node.type === 'script' && node.attribs?.src) {
    return <ScriptContent src={node.attribs.src} />
  }
}
